import {
  address,
  agencyAdmin,
  company,
  deployment,
  job,
  joboffer,
  order,
  product,
  reason,
  region,
  trader,
  traderAdmin,
  transaction,
  user,
} from '@homeserve/vue-api-plugin';
import { auth } from '@homeserve/vue-auth-plugin';
import Vue from 'vue';
import Vuex, { ActionContext } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

type AppContext = ActionContext<AppState, {}>;

export interface AppState {
  authRedirectRouteName?: string;
  loading: boolean;
  previousRouteName?: string;
}

const state: AppState = {
  loading: false,
};

const getters = {
  authRedirectRouteName(s: AppState) {
    return s.authRedirectRouteName;
  },
  loading(s: AppState) {
    return s.loading;
  },
  previousRouteName(s: AppState) {
    return s.previousRouteName;
  },
};

const mutations = {
  authRedirectRouteName(s: AppState, routeName?: string) {
    s.authRedirectRouteName = routeName;
  },
  loading(s: AppState, loading: boolean) {
    s.loading = loading;
  },
  previousRouteName(s: AppState, routeName: string) {
    s.previousRouteName = routeName;
  },
};

const actions = {
  authRedirectRouteName(context: AppContext, routeName?: string) {
    context.commit('authRedirectRouteName', routeName);
  },
  loading(context: AppContext, loading: boolean) {
    context.commit('loading', loading);
  },
};

const effectsPlugin = currentStore => {
  currentStore.subscribe(mutation => {
    if (mutation.type === 'auth/logout') {
      currentStore.commit('api/user/user/user', null);
    }
  });
};

const store = new Vuex.Store({
  actions,
  getters,
  plugins: [
    createPersistedState({
      key: process.env.VUE_APP_LOCALSTORAGE_KEY,
      paths: ['api.user.user.user', 'auth', 'authRedirectRouteName'],
    }),
    effectsPlugin,
  ],
  modules: {
    auth,
    api: {
      namespaced: true,
      modules: {
        address,
        admin: {
          namespaced: true,
          modules: {
            agency: agencyAdmin,
            company,
            trader: traderAdmin,
          },
        },
        catalog: {
          namespaced: true,
          modules: {
            product,
          },
        },
        order: {
          namespaced: true,
          modules: {
            order,
            job,
            transaction,
            deployment,
            reason,
          },
        },
        trader: {
          namespaced: true,
          modules: {
            trader,
            region,
          },
        },
        marketplace: {
          namespaced: true,
          modules: {
            joboffer,
          },
        },
        user: {
          namespaced: true,
          modules: {
            user,
          },
        },
      },
    },
  },
  mutations,
  state,
});

// force reset
store.commit('auth/errorAuthenticatingUser', null);

export default store;
